function set(value) {
  document.cookie = value;
}

export default {
  set,
};
